import { OptionsParam, ProductQueryParam } from '../../../../globalTypes';
export var queryParamToCoreMap = new Map([
    ['EXTRAS', ProductQueryParam.EXTRAS],
    ['FLIGHT_AIRLINE_CODES', ProductQueryParam.FLIGHT_AIRLINE_CODES],
    ['FLIGHT_DEPARTURE_AIRPORT_CODES', ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_CODES],
    ['FLIGHT_DEPARTURE_AIRPORT_GROUPS', ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_GROUPS],
    ['FLIGHT_STOP_OVER_MAX', ProductQueryParam.FLIGHT_STOP_OVER_MAX],
    ['HOTEL_CATEGORY', ProductQueryParam.HOTEL_CATEGORY],
    ['HOTEL_ROOM_VIEW_CODES', ProductQueryParam.HOTEL_ROOM_VIEW_CODES],
    ['OPTIONS', ProductQueryParam.OPTIONS],
    ['PRICE_MAX', ProductQueryParam.PRICE_MAX],
    ['PRICE_MIN', ProductQueryParam.PRICE_MIN],
    ['TOUR_OPERATOR_CODES', ProductQueryParam.TOUR_OPERATOR_CODES],
    ['TRAVEL_PERIOD_DEPARTURE_DATE', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DATE],
    ['TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE', ProductQueryParam.TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE],
    ['TRAVEL_PERIOD_DEPARTURE_DAYS', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DAYS],
    ['TRAVEL_PERIOD_DEPARTURE_TIME_MAX', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX],
    ['TRAVEL_PERIOD_DEPARTURE_TIME_MIN', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN],
    ['TRAVEL_PERIOD_DURATION', ProductQueryParam.TRAVEL_PERIOD_DURATION],
    ['TRAVEL_PERIOD_RETURN_DATE', ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE],
    ['TRAVEL_PERIOD_RETURN_TIME_MAX', ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX],
    ['TRAVEL_PERIOD_RETURN_TIME_MIN', ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN],
    ['TRAVELLERS_ADULTS', ProductQueryParam.TRAVELLERS_ADULTS],
]);
export var optionParamToCoreMap = new Map([
    ['PHUB_FLIGHT_IGNORE_OPEN_JAW', OptionsParam.PHUB_FLIGHT_IGNORE_OPEN_JAW]
]);
export var urlQueryParamProcessorMap = new Map([]);
export var urlToStepDateQueryParamMap = new Map([]);
export var urlToStepFlightsQueryParamMap = new Map([]);
export var urlToStepRoomsQueryParamMap = new Map([]);
export var urlToStepDateQueryProcessorMap = new Map([]);
export var urlToStepFlightsQueryProcessorMap = new Map([]);
export var urlToStepRoomsQueryProcessorMap = new Map([]);
export var queryParamToAliasMap = new Map([
    ['extras', ProductQueryParam.EXTRAS],
    ['airlines', ProductQueryParam.FLIGHT_AIRLINE_CODES],
    ['airports', ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_CODES],
    ['airportGroups', ProductQueryParam.FLIGHT_DEPARTURE_AIRPORT_GROUPS],
    ['flightStops', ProductQueryParam.FLIGHT_STOP_OVER_MAX],
    ['hotelCategory', ProductQueryParam.HOTEL_CATEGORY],
    ['roomViews', ProductQueryParam.HOTEL_ROOM_VIEW_CODES],
    ['options', ProductQueryParam.OPTIONS],
    ['priceMax', ProductQueryParam.PRICE_MAX],
    ['priceMin', ProductQueryParam.PRICE_MIN],
    ['tourOperatorCodes', ProductQueryParam.TOUR_OPERATOR_CODES],
    ['departureDate', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DATE],
    ['exactDepartureDate', ProductQueryParam.TRAVEL_PERIOD_EXACT_DEPARTURE_DATE],
    ['preferredDepartureDate', ProductQueryParam.TRAVEL_PERIOD_PREFERRED_DEPARTURE_DATE],
    ['departureDays', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DAYS],
    ['departureTimeMax', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX],
    ['departureTimeMin', ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN],
    ['duration', ProductQueryParam.TRAVEL_PERIOD_DURATION],
    ['returnDate', ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE],
    ['returnTimeMax', ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX],
    ['returnTimeMin', ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN],
    ['adults', ProductQueryParam.TRAVELLERS_ADULTS],
    ['childrenAges', ProductQueryParam.TRAVELLERS_CHILDREN_AGE],
]);
export var queryAliasToParamMap = new Map(inverseMap(queryParamToAliasMap));
export var optionParamToAliasMap = new Map([
    ['noOpenJaw', OptionsParam.PHUB_FLIGHT_IGNORE_OPEN_JAW],
]);
export var optionAliasToParamMap = new Map(inverseMap(optionParamToAliasMap));
export function inverseMap(inputMap) {
    var inverse = new Map();
    inputMap.forEach(function (v, k) { return inverse.set(v, k); });
    return inverse;
}
